let customTextTopForm = `<div class="koda-pro-content-top">
                <span>Please fill out the B2B trade program application below. You should recieve an initial response from KODA in 2-3 business days. At that time we'll ask you for any tax-exempt documents by email. After that, we let you know if you are approved into the program.</span>

                <div class="koda-pro-content-text warning-text">WARNING: The KODA PRO discount will only make financial sense for orders of $2K-$3K (or more). If you have an existing KODA shopper account, we encourage you to use a DIFFERENT EMAIL address for your KODA PRO account. See full disclaimer at bottom*.</div>
              </div>`;

let customTextBottomForm = `<div class="koda-pro-content-bottom">
                  <div> *KODA PRO accounts must place orders of $3,000 or more to enjoy free shipping. Orders less than $3K will be charged fixed shipping costs in the intervals below. Normal KODA shoppers get free shipping on orders of $50 or more. That is why we encourage you to use a different email for your KODA PRO account.</div>
                  <br/>
                  <div class="koda-pro-content-text">Fixed shipping costs are in the following intervals:</div>
                  <br/>
                  <div>Orders of $999 or less = $100</div>
                  <div>$1,000 to $1,999 = $200</div>
                  <div>$2,000 to $2,999 = $300</div>
              </div>`;


window.onload = () => {

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.addedNodes.length) {
        const appElement = document.querySelector(".koda-pro-online-application-new");

        if (appElement) {
          // 停止觀察，避免多次觸發
          observer.disconnect();

          // 執行操作
          setTimeout(() => {
            // 插入上方文字內容
            const formTitle = document.querySelector('.bss-b2b-registration-form-title')
            console.log('formTitle', formTitle)
            if (formTitle) {

              formTitle.insertAdjacentHTML('afterend', customTextTopForm);
            }

            // 替換 input 元素為 button 元素
            const inputElement = document.querySelector('.bss-b2b-rf-submit-button input');
            console.log('inputElement', inputElement)
            if (inputElement) {
              const buttonElement = document.createElement('button');
              buttonElement.classList.add('btn', 'btn--primary');
              buttonElement.textContent = 'Submit';
              inputElement.replaceWith(buttonElement);
            }

            // 插入下方文字內容
            const formButton = document.querySelector('.bss-b2b-rf-submit-button')
            console.log('formButton', formButton)
            if (formButton) {
              formButton.insertAdjacentHTML('beforebegin', customTextBottomForm)
            }
          }, 500)
        }
      }
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });
}

